export default {
  default: () => import("/root/workspace/whale-homepage_AeEf/layouts/default.vue").then(m => m.default || m),
  empty: () => import("/root/workspace/whale-homepage_AeEf/layouts/empty.vue").then(m => m.default || m)
}